/* eslint-disable max-len */
import React from 'react';

interface IDeleteProps {
    width?: number | string;
    height?: number | string;
}

const Delete: React.FC<IDeleteProps> = ({width = 12, height = 12}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.01786 0.414844L3.85714 0.75H1.71429C1.3192 0.75 1 1.08516 1 1.5C1 1.91484 1.3192 2.25 1.71429 2.25H10.2857C10.6808 2.25 11 1.91484 11 1.5C11 1.08516 10.6808 0.75 10.2857 0.75H8.14286L7.98214 0.414844C7.86161 0.159375 7.61384 0 7.34375 0H4.65625C4.38616 0 4.13839 0.159375 4.01786 0.414844ZM10.2857 3.3H6H1.71429L2.1875 10.9453C2.22321 11.5383 2.69196 12 3.2567 12H8.7433C9.30804 12 9.77679 11.5383 9.8125 10.9453L10.2857 3.3Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Delete;